var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a;
import { useEffect, useMemo, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { InternalTagType, SettingType } from '@common/api';
import { ChartType } from '@shared/chart/util';
import { cartesian } from '@util/cartesian';
import * as baobab from '@data/baobab/baobab';
import { evaluatorApi } from '@data/rest/api';
import { Chart } from '@util/enums';
import { useSetting } from './settings';
import { LastPromise } from './modelTable';
import { useTagContext } from '../tag/tagContext';
import { isGroupTag } from '../tag/types';
import { useActiveVersions } from './versions';
var prefixMap = (_a = {},
    _a[InternalTagType.Month] = { old: 'M', new: '' },
    _a[InternalTagType.Year] = { old: 'Y', new: '' },
    _a[InternalTagType.YearToDate] = { old: 'M', new: 'YTD-' },
    _a);
export default function useChartData(widgetId, widgetConfig, tagSlicersTagIds) {
    var _this = this;
    var _a;
    var EvaluateLast = useRef(new LastPromise());
    var tagData = useTagContext().tagData;
    var financialYearStartingMonth = useSetting(SettingType.FinancialYearStartingMonth);
    var offset = +((_a = financialYearStartingMonth === null || financialYearStartingMonth === void 0 ? void 0 : financialYearStartingMonth.value) !== null && _a !== void 0 ? _a : 1) - 1;
    var versions = useActiveVersions();
    var _b = __read(useState(null), 2), data = _b[0], setData = _b[1];
    var _c = __read(useState(null), 2), lastFetched = _c[0], setLastFetched = _c[1];
    var _d = __read(useState(''), 2), currentDataKey = _d[0], setCurrentDataKey = _d[1];
    var _e = __read(useMemo(function () {
        var e_1, _a;
        var filteredAxisData = widgetConfig.xAxisTagIds.filter(function (tagIds) { return !!tagIds.length; });
        for (var i = 0; i < filteredAxisData.length; i++) {
            filteredAxisData[i] = filteredAxisData[i].filter(function (id) { return !!tagData.tagById[id]; });
        }
        var slicerOrTagIds = [];
        if (widgetConfig.useTagSlicers) {
            for (var tagSlicerWidgetId in tagSlicersTagIds) {
                if (Object.prototype.hasOwnProperty.call(tagSlicersTagIds, tagSlicerWidgetId)) {
                    var tagIds = tagSlicersTagIds[Number(tagSlicerWidgetId)];
                    if (tagIds === undefined) {
                        continue;
                    }
                    tagIds.sort();
                    slicerOrTagIds.push(tagIds.join('|'));
                }
            }
        }
        if (!filteredAxisData.length || widgetConfig.chartType === Chart.PIE) {
            return [["tags(".concat(slicerOrTagIds.join(','), ")")], ['']];
        }
        var combinations = cartesian.apply(void 0, __spreadArray([], __read(filteredAxisData), false));
        var tds = [];
        var tl = [];
        try {
            for (var combinations_1 = __values(combinations), combinations_1_1 = combinations_1.next(); !combinations_1_1.done; combinations_1_1 = combinations_1.next()) {
                var c = combinations_1_1.value;
                var label = c
                    .map(function (id) {
                    var tag = tagData.tagById[id];
                    if (!tag) {
                        return '';
                    }
                    if (!!tag.internalType) {
                        var targetPrefix = prefixMap[tag.internalType];
                        var trimmed = targetPrefix ? tag.name.replace(targetPrefix.old, '') : tag.name;
                        var result = trimmed;
                        if (tag.internalType === InternalTagType.Month ||
                            tag.internalType === InternalTagType.YearToDate) {
                            result = +trimmed + offset > 12 ? +trimmed + offset - 12 : +trimmed + offset;
                        }
                        return targetPrefix ? targetPrefix.new + result : result;
                    }
                    return tag.description ? "".concat(tag.name, " ").concat(tag.description) : tag.name;
                })
                    .join('/');
                var evaluationData = "tags(".concat(c.join(','), ",").concat(slicerOrTagIds.join(','), ")");
                tds.push(evaluationData);
                tl.push(label);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (combinations_1_1 && !combinations_1_1.done && (_a = combinations_1.return)) _a.call(combinations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (widgetConfig.chartHorizontal) {
            var reversedTds = tds.reverse();
            var reversedTl = tl.reverse();
            return [reversedTds, reversedTl];
        }
        return [tds, tl];
    }, [
        JSON.stringify(widgetConfig.xAxisTagIds),
        widgetConfig.useTagSlicers,
        JSON.stringify(tagSlicersTagIds),
        JSON.stringify(tagData.tagById),
    ]), 2), timeDataStrings = _e[0], labels = _e[1];
    var lineDataStrings = useMemo(function () {
        if (widgetConfig.lines.length === 0) {
            return [];
        }
        else {
            var lds_1 = [];
            widgetConfig.lines.map(function (line) {
                var lineTagIds = [];
                if (typeof line.tags === 'string') {
                    lineTagIds = line.tags ? __spreadArray([], __read(line.tags), false) : [];
                }
                else {
                    lineTagIds = line.tags;
                }
                if (line.variation) {
                    var version = versions.find(function (v) { return v.id === line.variation; });
                    if (version) {
                        lineTagIds.push(version.versionTagId);
                    }
                }
                lds_1.push(getDataString(lineTagIds.filter(function (id) { return !isGroupTag(tagData.tagById[id]); })));
            });
            return lds_1;
        }
    }, [versions, widgetConfig, JSON.stringify(tagData.tagById)]);
    var key = useMemo(function () { return lineDataStrings.join(',') + timeDataStrings.join(','); }, [lineDataStrings, timeDataStrings]);
    // data fetch:
    var fetch = function (rs, cs) { return __awaiter(_this, void 0, void 0, function () {
        var res, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    baobab.root.select('state', 'widgetsLoading', widgetId).set(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, EvaluateLast.current.pushPromise(function () { return __awaiter(_this, void 0, void 0, function () {
                            var data;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, evaluatorApi.evaluate({ rows: rs, cols: cs })];
                                    case 1:
                                        data = _a.sent();
                                        return [2 /*return*/, {
                                                key: key,
                                                data: data,
                                            }];
                                }
                            });
                        }); })];
                case 2:
                    res = _a.sent();
                    setLastFetched(res);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    toast.error('Error loading chart data.');
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    baobab.root.select('state', 'widgetsLoading', widgetId).set(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (timeDataStrings.length > 0 && lineDataStrings.length > 0) {
            if (key !== currentDataKey && data) {
                setData(null);
            }
            fetch(lineDataStrings, timeDataStrings);
        }
    }, [key]);
    useEffect(function () {
        if (lastFetched && lastFetched.data && key === (lastFetched === null || lastFetched === void 0 ? void 0 : lastFetched.key)) {
            setCurrentDataKey(lastFetched.key);
            setData(lastFetched.data);
            baobab.root.select('state', 'widgetsLoading', widgetId).set(false);
        }
    }, [lastFetched]);
    var chartData = useMemo(function () {
        if (data && data.length > 0) {
            var cd_1 = {
                numberOfBars: 0,
                labels: [],
                lines: [],
                maxValue: 0,
                minValue: 0,
            };
            widgetConfig.lines.forEach(function (line, idx) {
                var lineData = data && data[idx] ? data[idx].map(function (d) { return d.value; }) : [];
                var item = getChartLine(line, lineData, labels);
                if (item.maxValue > cd_1.maxValue) {
                    cd_1.maxValue = item.maxValue;
                }
                if (item.minValue < cd_1.minValue) {
                    cd_1.minValue = item.minValue;
                }
                if (cd_1.labels.length === 0) {
                    cd_1.labels = item.labels;
                }
                if (line.stacked === 0) {
                    cd_1.lines.push(item);
                    if (line.chartType === ChartType.BAR) {
                        cd_1.numberOfBars = cd_1.numberOfBars + 1;
                    }
                }
                else {
                    if (cd_1.lines.find(function (cdl) { return cdl.stacked === line.stacked; })) {
                        var stackIdx = cd_1.lines.findIndex(function (cdl) { return cdl.stacked === line.stacked; });
                        cd_1.lines[stackIdx].lineData = cd_1.lines[stackIdx].lineData.concat(item.lineData);
                    }
                    else {
                        cd_1.lines.push(item);
                        if (line.chartType === ChartType.BAR) {
                            cd_1.numberOfBars = cd_1.numberOfBars + 1;
                        }
                    }
                }
            });
            return cd_1;
        }
        else {
            return {
                numberOfBars: 0,
                labels: [],
                lines: [],
                maxValue: 0,
                minValue: 0,
            };
        }
    }, [data, JSON.stringify(widgetConfig.lines)]);
    return chartData;
}
function getChartLine(line, values, labels) {
    var points = values.map(function (value, idx) {
        return {
            x: idx + 1,
            y: value !== null && value !== void 0 ? value : 0,
            title: line.title,
            color: line.color,
        };
    });
    return {
        chartType: line.chartType,
        stacked: line.stacked,
        lineData: [{ points: points, color: line.color }],
        labels: labels,
        maxValue: Math.max.apply(Math, __spreadArray([], __read(values.filter(function (v) { return v !== null; })), false)),
        minValue: Math.min.apply(Math, __spreadArray([], __read(values.filter(function (v) { return v !== null; })), false)),
    };
}
function getDataString(arr) {
    arr.sort(function (a, b) {
        var aa = Array.isArray(a) ? a[0] : a;
        var bb = Array.isArray(b) ? b[0] : b;
        return aa - bb;
    });
    var tags = arr.map(function (item) {
        if (Array.isArray(item)) {
            return item.join('|');
        }
        else {
            return "".concat(item);
        }
    });
    return "tags(".concat(tags.join(','), ")");
}
